import dynamic from "next/dynamic"

const Icon = dynamic(() => import("@ipex/storybook").then(mod => mod.Icon), {
  ssr: false,
  loading: () => null,
})

export default Icon
